import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InboxComponent } from './pages/inbox/inbox.component';
import { ThreadComponent } from '@app/modules/inbox/pages/thread/thread.component';
import { FeatureFlagEnabledGuard } from '@app/shared/guards/feature-flag-enabled.guard';

const routes: Routes = [
  {
    path: 'segments/:activeSegment',
    component: InboxComponent,
    data: {
      title: 'Inbox',
      identifier: 'inbox',
      shouldReuse: false,
    },
  },
  {
    path: 'thread-beta/:id',
    component: ThreadComponent,
    canActivate: [FeatureFlagEnabledGuard],
    data: {
      title: 'Thread',
      permanent: true,
      redirectTo: '/inbox/thread/:id',
    },
  },
  {
    path: 'thread/:id',
    component: ThreadComponent,
    data: {
      shouldReuse: false,
    },
  },
  {
    path: '',
    redirectTo: '/inbox/segments/default',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InboxRoutingModule {}
